var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGlobe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "globe",
    d: "M13.75,10a24.425,24.425,0,0,1-.129,2.5H6.379A23.362,23.362,0,0,1,6.25,10a24.425,24.425,0,0,1,.129-2.5h7.242A23.361,23.361,0,0,1,13.75,10Zm1.125-2.5h4.809a10.035,10.035,0,0,1,0,5H14.875A24.68,24.68,0,0,0,15,10,24.68,24.68,0,0,0,14.875,7.5Zm4.4-1.25H14.715A13.74,13.74,0,0,0,12.555.328,10.02,10.02,0,0,1,19.27,6.25Zm-5.824,0h-6.9a15.744,15.744,0,0,1,1.055-3.7A6.381,6.381,0,0,1,8.914.539,1.614,1.614,0,0,1,10,0a1.614,1.614,0,0,1,1.086.539,6.381,6.381,0,0,1,1.309,2.012A15.274,15.274,0,0,1,13.449,6.25Zm-8.164,0H.727A10.026,10.026,0,0,1,7.445.328,13.74,13.74,0,0,0,5.285,6.25ZM.316,7.5H5.125a25.062,25.062,0,0,0,0,5H.316a10.035,10.035,0,0,1,0-5Zm7.289,9.945a15.471,15.471,0,0,1-1.055-3.7h6.9a15.654,15.654,0,0,1-1.055,3.7,6.381,6.381,0,0,1-1.309,2.012A1.605,1.605,0,0,1,10,20a1.614,1.614,0,0,1-1.086-.539,6.381,6.381,0,0,1-1.309-2.012Zm-2.32-3.7a13.74,13.74,0,0,0,2.16,5.922A10.026,10.026,0,0,1,.727,13.75Zm13.988,0a10.028,10.028,0,0,1-6.715,5.922,13.79,13.79,0,0,0,2.16-5.922Z",
    fill: "#003087"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobe);
export default __webpack_public_path__ + "static/media/globe.e815fde00b23cb1c5b77a78e69369975.svg";
export { ForwardRef as ReactComponent };